import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loading, Ellipsis } from 'antd-mobile'
// import { CloseOutline } from 'antd-mobile-icons'
import dayjs from 'dayjs'
import PopupContent from '../PopupContent'
import PromotionDetail from './Detail'
import KeepAlivePopup from '../KeepAlivePopup'
import { getActivityNextModel, getActivityModel, getCouponRuleModel } from '../../model/store'
import { getLanguageStore } from '../../utils/storage/language'
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp'
// import CouponList from '../CouponList'
import AutoImage from '../AutoImage'
// import PopupProducts from './PopupProducts'
import defImg from '../../assets/images/def_img_food.png'
import CalendarIcon from '../../components/Icon/CalendarIcon'
import CouponModal from './CouponModal'
import BookingModal from './BookingModal'
import { formatJSON } from '../../utils'
import { getMemberInfo } from '../../utils/storage/store'
import { getScopeParam } from '../../utils/session/store'
import { useDispatch } from 'react-redux'
import { setPmList } from '../../store/reducers/hotel'


import './index.less'

// 常量定义
const CONSTANTS = {
    DEFAULT_POSITIONS: '401,405,403,407',
    DEFAULT_RELATE_TYPE: 802,
    DEFAULT_DIRECTION: 'horizontal',
    DEFAULT_FROM: 'merchant',
    CONTENT_TYPES: {
        COUPON: 3,
        PRODUCT: 4,
        BOOKING: [1, 4, 5, 6]
    },
    POPUP_PARAM: '1',
    POPUP_MODAL: true
}

// 工具函数
const formatTime = (time) => dayjs(time).format('YYYY-MM-DD')

const getImageSrc = (imageArray) => {
    return imageArray?.length > 0 ? imageArray[0] : defImg
}

const getListStyle = (direction) => {
    if (direction === 'vertical') {
        return {
            className: 'adm-grid pd-list-vertical',
            style: {
                '--columns': 2,
                '--gap-horizontal': '15px',
            }
        }
    }
    return { className: '', style: null }
}

// 子组件：促销项目
const PromotionItem = React.memo(({ item, from, onItemClick }) => {
    const img = getImageSrc(item.imageArray)

    return (
        <li className='pd-item jm-flex' onClick={() => onItemClick(item)}>
            <div className='pd-img-wrapper'>
                <AutoImage src={img} alt="product" size='b' />
            </div>
            <div className='pd-content jm-flex-item'>
                <div className='pd-name ellips_line2'>
                    <b>{item.activityTitle}</b>
                </div>
                {from === 'chain' && (
                    <div className='pd-store-name m-t-sm'>
                        {item.shortName || item.storeName}
                    </div>
                )}
                {item.briefDescription && (
                    <div className='pm-desc'>
                        <Ellipsis content={item.briefDescription} />
                    </div>
                )}
                {item.startTime && item.endTime && (
                    <div className='pm-desc pm-time jm-flex'>
                        <CalendarIcon width={16} height={16} color='var(--adm-color-primary)' />
                        <div style={{ color: '#c7c7c7' }}>
                            &nbsp;{formatTime(item.startTime)} - {formatTime(item.endTime)}
                        </div>
                    </div>
                )}
            </div>
        </li>
    )
})

const PromotionList = ({
    areaId = '',
    partnerId = '',
    relateId = '',
    positions = CONSTANTS.DEFAULT_POSITIONS,
    relateType = CONSTANTS.DEFAULT_RELATE_TYPE,
    direction = CONSTANTS.DEFAULT_DIRECTION,
    from = CONSTANTS.DEFAULT_FROM,
    popup = '',
    cStyle = {},
    popupModal = CONSTANTS.POPUP_MODAL,
    storeInfo = {}
}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { memberId = '' } = getMemberInfo() || {}
    const { roomTypeId } = from === CONSTANTS.DEFAULT_FROM ? storeInfo?.storeArea : storeInfo
    // 状态管理
    const [state, setState] = useState({
        pmList: [],
        pmDetail: null,
        isLoading: false,
        couponVisible: false,
        curCoupon: null,
        bookingBoxVisible: false,
        bookingProducts: []
    })

    // 更新状态的辅助函数
    const updateState = useCallback((updates) => {
        setState(prev => ({ ...prev, ...updates }))
    }, [])

    // 获取优惠券规则
    const getCouponRule = useCallback(async (ids) => {
        try {
            const res = await getCouponRuleModel({
                couponRuleIds: ids,
                curLanguage: getLanguageStore,
                memberId
            }, true)
            return res.filter(item => !item.couponState)
        } catch (error) {
            console.error('获取优惠券规则失败:', error)
            return []
        }
    }, [memberId])

    // 显示优惠券弹窗
    const popupCouponContent = useCallback(async (item) => {
        let nObj = {}
        if (Array.isArray(item)) {
            if (item.length === 0) return

            if (from === 'chain') {
                item = item.filter(item => item.relateType === CONSTANTS.DEFAULT_RELATE_TYPE)
            }

            if (item.length === 1) {
                nObj = { ...item[0] }
            } else {
                nObj.list = item
                nObj.param2 = item.map(o => o.param2).join(',')
            }
        }
        if (!nObj?.param2) return

        const couponList = await getCouponRule(nObj.param2)
        if (couponList.length > 0) {
            setTimeout(() => {
                updateState({ couponVisible: true, curCoupon: nObj })
            }, 1000)
        }
    }, [getCouponRule, updateState])

    // 显示预订弹窗
    const popupBookingBox = useCallback((arr) => {
        if (arr.length > 0) {
            if (from === 'chain') {
                arr = arr.filter(item => item.relateType === CONSTANTS.DEFAULT_RELATE_TYPE)
            }
            updateState({ bookingBoxVisible: true, bookingProducts: arr })
        }
    }, [updateState])

    // 显示促销详情
    const showPMDetail = useCallback((item, placeFlag = 3) => {
        // if (item.contentType === CONSTANTS.CONTENT_TYPES.PRODUCT) {
        //     navigate(`/relate-product?productId=${item.param2}`)
        // } else {
        updateState({ pmDetail: { ...item, placeFlag } })
        // }


        //列表点击行为统计
        addBehaviorsRecord({
            behaviorType: 160100,
            behavior: 160101,
            storeId: storeInfo.storeId,
            value1: placeFlag || 3,
            value2: item.activityId,
            value3: item.contentType
        })
    }, [navigate, updateState])

    // 关闭弹窗
    const closeModal = useCallback((modalType) => {
        const updates = {}
        if (modalType === 'coupon') {
            updates.couponVisible = false
            updates.curCoupon = null
        } else if (modalType === 'booking') {
            updates.bookingBoxVisible = false
            updates.bookingProducts = []
        } else if (modalType === 'detail') {
            updates.pmDetail = null
        }
        updateState(updates)
    }, [updateState])

    // 获取活动数据
    const fetchActivityData = useCallback(async () => {
        updateState({ isLoading: true })

        try {
            const isChain = from === 'chain'
            const model = isChain ? getActivityNextModel : getActivityModel
            const param = {
                areaId,
                partnerId,
                relateId,
                positions,
                curLanguage: getLanguageStore(),
                ...(isChain ? { relateTypes: relateType } : { relateType })
            }

            let res = await model(param)
            //不适用房型
            if (roomTypeId) {
                res = res.filter(item => {
                    const { extendColumn } = item
                    const extendObj = formatJSON(extendColumn)
                    if (extendObj && extendObj.notApplicableRoomTypeIds) {
                        const notApplicableRoomTypeIds = extendObj.notApplicableRoomTypeIds.split(',').map(id => parseInt(id))
                        return !notApplicableRoomTypeIds.includes(roomTypeId)
                    }
                    return true
                })
            }

            // 处理数据
            const couponItem = res.filter(item =>
                item.contentType === CONSTANTS.CONTENT_TYPES.COUPON &&
                item.param3 === CONSTANTS.POPUP_PARAM
            )

            const bProducts = res.filter(item =>
                CONSTANTS.CONTENT_TYPES.BOOKING.includes(item.contentType) &&
                item.param3 === CONSTANTS.POPUP_PARAM
            )

            /*
            // 过滤列表
            const filteredList = res.filter(item => {
                const isInCouponItem = couponItem && item.activityId === couponItem.activityId
                const isInBProducts = bProducts.some(product => product.activityId === item.activityId)
                return !isInCouponItem && !isInBProducts
            })
            //*/
            const filteredList = res//.filter(item => item.position !== popup)

            updateState({
                pmList: filteredList,
                isLoading: false
            })
            if (popupModal) {
                // 触发弹窗
                popupCouponContent(couponItem)
                popupBookingBox(bProducts)
            }
            // 更新 Redux store
            dispatch(setPmList({ [from || 'merchant']: filteredList }))

        } catch (error) {
            console.error('获取活动数据失败:', error)
            updateState({ isLoading: false })
        }
    }, [areaId, partnerId, relateId, positions, relateType, from, popup, popupCouponContent, popupBookingBox, dispatch, updateState, roomTypeId])

    // 数据获取效果
    useEffect(() => {
        fetchActivityData()
    }, [fetchActivityData])

    // 计算样式
    const listStyle = useMemo(() => getListStyle(direction), [direction])

    // 渲染加载状态
    if (state.isLoading) {
        return (
            <div className='pm-wrapper'>
                <div className='pm-loading'>
                    <Loading />
                </div>
            </div>
        )
    }

    return (
        <div className='pm-wrapper'>
            <ul className={`pd-list ${listStyle.className}`} style={{ ...listStyle.style, ...cStyle }}>
                {state.pmList.map((item, index) => (
                    <PromotionItem
                        key={`${item.activityId || index}`}
                        item={item}
                        from={from}
                        onItemClick={showPMDetail}
                    />
                ))}
            </ul>

            {/* 详情弹窗 */}
            {state.pmDetail && (
                <KeepAlivePopup
                    visible={!!state.pmDetail}
                    onClose={() => closeModal('detail')}
                    position='bottom'
                >
                    <PopupContent>
                        <PromotionDetail
                            detail={{ ...state.pmDetail }}
                            callback={() => closeModal('detail')}
                        />
                    </PopupContent>
                </KeepAlivePopup>
            )}

            {/* 优惠券弹窗 */}
            <CouponModal
                visible={state.couponVisible}
                coupon={state.curCoupon}
                onClose={() => closeModal('coupon')}
                storeId={storeInfo.storeId}
                placeFlag={1}
            />

            {/* 预订弹窗 */}
            <BookingModal
                visible={state.bookingBoxVisible}
                products={state.bookingProducts}
                onClose={() => closeModal('booking')}
                onItemClick={(item) => {
                    showPMDetail(item, 1)
                }}
            />
        </div>
    )
}

export default PromotionList
